export const truncate = (input: string | null, maxLength: number) => {
    if (input && input.length > maxLength)
        return `${input.substring(0, maxLength)}...`
    return input
}

export const capitalize = (str: string) => {
    return str.charAt(0).toUpperCase() + str.slice(1)
}
